import cloudemployee from '../../../assets/CloudEmployee.jpg'
import miller from '../../../assets/Miller.png'
import globe from '../../../assets/Globe.png'
import accenture from '../../../assets/Accenture.png'
import analog from '../../../assets/Analog.png'

export const jobs = [
    {
        title: 'Fullstack Developer',
        name: 'Cloud Employee APAC',
        dates: 'June 2023 - Present',
        logo: cloudemployee,
        descriptions: []
    },
    {
        title: 'Software Developer',
        name: 'Miller Code Factory',
        dates: 'January 2022 - June 2023',
        logo: miller,
        descriptions: []
    },
    {
        title: 'Technical Support Engineer',
        name: 'Globe Telecom, Inc.',
        dates: 'July 2021 - January 2022',
        logo: globe,
        descriptions: []    
    },
    {
        title: 'Associate Software Engineer',
        name: 'Accenture',
        dates: 'May 2020 - June 2021',
        logo: accenture,
        descriptions: []
    },
    {
        title: 'Equipment Engineer',
        name: 'Analog Devices, Inc.',
        dates: 'March 2021 - May 2020',
        logo: analog,
        descriptions: []
    }
];
